import Image from 'next/image'
import Link from 'next/link'
import { Button } from '@/components/ui/button'

export default function Hero() {
  return (
    <div className="relative overflow-x-hidden">
      <div className="bg-wrap">
        <Image
          className="h-full w-full select-none object-cover"
          src="/images/for-pro/v2/hero-bg.png"
          width="1480"
          height="541"
          alt=""
          priority
        />
      </div>
      <div className="container relative py-20">
        <div className="hidden absolute top-0 bottom-0 -right-10 xl:flex items-center">
          <Image
            className="select-none"
            src="/images/for-pro/v2/hero-image.png"
            width="674"
            height="300"
            alt="professional"
          />
        </div>
        <div className="relative">
          <h1 className="mb-10 leading-tight text-white text-3xl sm:text-4xl md:text-5xl">
            あなたの音楽スキルが、<br />
            誰かの夢を形にする。
          </h1>
          <p className="mb-10 text-base text-white md:text-lg">
            音楽制作のクリエイターが集まり、活躍できるプラットフォーム。
          </p>
          <div className="hidden sm:block">
            <Button size="xl" asChild variant="primary">
              <Link href="/register-pro">
                クリエイターとして登録する
              </Link>
            </Button>
          </div>
          <div className="sm:hidden">
            <Button size="lg" asChild variant="primary">
              <Link href="/register-pro">
                クリエイターとして登録する
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
